import React from 'react';
import cx from 'classnames';
import {LockClosedIcon, LockOpenIcon} from '@heroicons/react-v2/20/solid';

import Link from '../../components/Link';
import LessonThumbnail from '../../components/LessonThumbnail';
import {Badge, DifficultyToBadge} from '../../components/Badge';
import {Checkmark} from '../../components/svg';
import {useAppContext} from '../../hooks';
import {getVideoThumbnailURL, isNewLesson} from '../../util';

const LessonCard = ({
  lesson,
  courseSlug,
  courseIsNew,
  trackSlug,
  className,
  onClickLesson,
}) => {
  const {hasSubscription} = useAppContext();

  let icon;

  if (lesson.comingSoon) {
    icon = <Badge>Coming soon</Badge>;
  } else if (!hasSubscription && !lesson.free) {
    icon = <LockClosedIcon className="h-4 w-4 flex-shrink-0 text-gray-400" />;
  } else if (lesson.markedAsComplete) {
    icon = <Checkmark className="h-4 w-4 flex-shrink-0" />;
  } else if (hasSubscription || lesson.free) {
    icon = <LockOpenIcon className="h-4 w-4 flex-shrink-0 text-gray-400" />;
  }

  const lessonURL = trackSlug
    ? `/courses/${trackSlug}/${courseSlug}/${lesson.slug}`
    : `/courses/${courseSlug}/${lesson.slug}`;

  return (
    <Link
      href={lessonURL}
      onClick={(e) => onClickLesson(e, lesson, courseSlug, trackSlug)}
      className={cx('group flex overflow-hidden border-t border-gray-200 first:border-0', {'text-gray-500': lesson.comingSoon}, className)}
    >
      {lesson.video && (
        <LessonThumbnail
          imageUrl={getVideoThumbnailURL(lesson.video)}
          className="opacity-90 group-hover:opacity-100 m-1.5 w-20 sm:w-24 xs:h-14"
        />
      )}
      <div className="py-4 px-5 flex w-full items-center justify-between truncate text-ellipsis">
        <span className="text-xs sm:text-sm text-gray-800 font-semibold text-ellipsis truncate mr-2">
          {lesson.shortTitle}
          {!hasSubscription && lesson.free && <Badge className="mx-2">Free</Badge>}
        </span>
        <span>
          {!courseIsNew && isNewLesson(lesson) && (
            <Badge className="mr-3">New</Badge>
          )}
          {lesson.difficulty && (
            <Badge className="mr-3" color={DifficultyToBadge[lesson.difficulty]?.color}>
              {DifficultyToBadge[lesson.difficulty]?.text}
            </Badge>
          )}
          {icon}
        </span>
      </div>
    </Link>
  );
};

export default LessonCard;
